import React, { useRef, useState } from 'react'
import { Box, HStack } from '@chakra-ui/react'
import { Editor } from '@monaco-editor/react'
import LanguageSelector from './LanguageSelector'
import { CODE_SNIPPETS } from './constants'
import Output from './Output'
import Coding_QnS from './Coding_QnS'
import { AiOutlineSolution } from "react-icons/ai";

const CodeEditor = () => {
  const editorRef = useRef(null)
  const [value, setValue] = useState(CODE_SNIPPETS['javascript'] || '') // Default to JavaScript if not defined
  const [language, setLanguage] = useState('javascript')

  const onMount = (editor) => {
    editorRef.current = editor
    editor.focus()
  }

  const onSelect = (language) => {
    setLanguage(language)
    setValue(CODE_SNIPPETS[language])
  }

  return (
    <div>
      <div className=''>
      {/* -------------------------------Mobile view--------------------------------- */}
      <div className='container d-sm-block d-md-none'>
        <div className='text-center mb-4 mobile_About_Discraption_text'>
          <h1 className='display-4 border-bottom pb-2 text-center'>Code Editor</h1>
        </div>
      </div>


      {/* -------------------------------Dasktop view--------------------------------- */}
      <div className='container d-none d-md-block'>
        <div className='row'>
            <div className='container px-5'>
            <div className='text-center mb-4 About_Discraption_text'>
                <h1 className='display-6 border-bottom pb-2'>Code Editor</h1>
            </div>
            </div>
        </div>
      </div>
    </div>
      <div className="container">
        <div className="row">
        <div className="col-md-5 d-md-none d-sm-block mb-4 Popular_cource_text">
          <h2 className='fs-4 pb-3'>Practice Question{' '}<AiOutlineSolution /></h2>
            <Coding_QnS/>
          </div>
          <div className="col-md-7">
            <div>
              <LanguageSelector language={language} onSelect={onSelect} />
              <Box>
                <vStack>
                  <Box w="100%" zIndex={-1}>
                    <Editor
                      options={{
                        minimap: {
                          enabled: false,
                        },
                      }}
                      height="61vh"
                      theme="vs-dark"
                      language={language}
                      value={value}
                      onMount={onMount}
                      onChange={(value) => setValue(value)}
                    />
                  </Box>
                  <Output editorRef={editorRef} language={language} />
                </vStack>
              </Box>
            </div>
          </div>
          <div className="col-md-5 d-none d-md-block pt-3 Popular_cource_text">
          <h2 className='fs-4 pb-3'>Practice Question{' '}<AiOutlineSolution /></h2>
            <Coding_QnS/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CodeEditor
